import { createContext, useContext, useState, useEffect } from "react";
import { saveAuth, clearAuth, getToken, getRole } from "../utils/auth";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);
  const [tenant, setTenant] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem("user");
      const storedTenant = localStorage.getItem("tenant");
      if (storedUser) setUser(JSON.parse(storedUser));
      if (storedTenant) setTenant(JSON.parse(storedTenant));
    } catch {
      // ignore
    }
    setLoading(false);
  }, []);

  const loginUser = (
    token: string,
    role: string,
    isSubscribed?: boolean,
    userData?: any,
    tenantData?: any
  ) => {
    saveAuth(token, role, isSubscribed);
    if (userData) {
      setUser(userData);
      localStorage.setItem("user", JSON.stringify(userData));
    }
    if (tenantData) {
      setTenant(tenantData);
      localStorage.setItem("tenant", JSON.stringify(tenantData));
    }

    if (role === "TENANT_ADMIN" && isSubscribed === false) {
      navigate("/subscription");
      return;
    }
    if (role === "SUPER_ADMIN") {
      navigate("/dashboard");
    } else if (role === "ADMIN" || role === "TENANT_ADMIN") {
      navigate("/admin");
    } else {
      navigate("/dashboard");
    }
  };

  const logout = () => {
    clearAuth();
    localStorage.removeItem("user");
    localStorage.removeItem("tenant");
    setUser(null);
    setTenant(null);
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ loginUser, logout, user, tenant, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
